import styled from '@emotion/styled'

const StyledContainer = styled.div`
  width: 100%;
  .rc-input-number {
    width: 100%;
    height: 38px;
    margin: 0;
    padding: 0;
    font-size: 13px;
    border-radius: 4px;
    transition: all 0.3s;
    border-color: transparent;
    border: 1px solid #dbdfea;
    ${({ style }) => {
      return { ...style }
    }}
  }

  .rc-input-number-handler-wrap {
    float: right;
    width: 20px;
    // height: 38px;
    height: 100%;
    border-radius: 0 4px 4px 0;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.03);
  }
  .rc-input-number-handler-up {
    /* padding-top: 1px; */
    /* border-bottom: 1px solid #d9d9d9; */
    transition: all 0.3s;
  }
  .rc-input-number-focused {
    border-color: rgb(var(--ow-primary-color));
    box-shadow: 0 0 0 3px rgba(var(--ow-primary-color), 0.1);
  }
  .rc-input-number-out-of-range input {
    color: red;
  }
  .rc-input-number-handler {
    display: block;
    height: 12px;
    overflow: hidden;
    line-height: 12px;
    text-align: center;
    touch-action: none;
  }
  .rc-input-number-handler-active {
    /* background: #ddd; */
  }
  .rc-input-number-handler-up-inner,
  .rc-input-number-handler-down-inner {
    color: #666;
    -webkit-user-select: none;
    user-select: none;
  }
  .rc-input-number:hover {
    /* border-color: #0056fe; */
  }
  .rc-input-number:hover .rc-input-number-handler-up,
  .rc-input-number:hover .rc-input-number-handler-wrap {
    /* border-color: #0056fe; */
  }
  .rc-input-number-disabled:hover {
    /* border-color: #d9d9d9; */
  }
  .rc-input-number-disabled:hover .rc-input-number-handler-up,
  .rc-input-number-disabled:hover .rc-input-number-handler-wrap {
    /* border-color: #d9d9d9; */
  }
  .rc-input-number-input-wrap {
    // height: 38px;
    height: 100%;
    overflow: hidden;
  }
  .rc-input-number-input {
    padding-left: 12px;
    width: 100%;
    height: 100%;
    color: #666;
    line-height: 40px;
    text-align: left;
    /* border: 0; */
    /* border-radius: 4px; */
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    outline: 0;
    transition: all 0.3s ease;
    transition: all 0.3s;
    -moz-appearance: textfield;
    background: #fff;
  }
  .rc-input-number-input:focus {
    background: #fff;
    /* border-width: 1px !important; */
  }
  .rc-input-number-input:focus .rc-input-number-handler-wrap {
    background: #fff !important;
  }
  .rc-input-number-handler-up-inner::after {
    content: '+';
  }
  .rc-input-number-handler-down {
    transition: all 0.3s;
  }
  .rc-input-number-handler-down-inner::after {
    content: '-';
  }
  .rc-input-number-handler-down-disabled,
  .rc-input-number-handler-up-disabled {
    opacity: 0.3;
  }
  .rc-input-number-handler-down-disabled:hover,
  .rc-input-number-handler-up-disabled:hover {
    color: #999;
    border-color: #d9d9d9;
  }
  .rc-input-number-disabled .rc-input-number-input {
    /* background-color: #f3f3f3; */
    cursor: not-allowed;
    /* opacity: 0.72; */
  }
  .rc-input-number-disabled .rc-input-number-handler {
    opacity: 0.3;
  }
  .rc-input-number-disabled .rc-input-number-handler:hover {
    color: #999;
    /* border-color: #d9d9d9; */
  }
`

export default StyledContainer
